import { assertLayoutNodeExhaustive } from './layoutAssertNever';
import { walkLayoutStructureChildren } from './layoutStructureChildLists';
import type { LayoutNode } from './types';
import {
  addConditionalClauseRefQidsToSet,
  addWhenGateRefQidsToSet,
} from './whenClause';

/** QIDs referenced by layout DSL (controls + predicates + weighted `sum` terms). */
export function collectLayoutReferencedQids(nodes: LayoutNode[]): Set<string> {
  const ids = new Set<string>();
  const walk = (arr: LayoutNode[]) => {
    for (const node of arr) {
      switch (node.type) {
        case 'card':
        case 'stack':
        case 'grid':
        case 'flex':
        case 'box':
        case 'indent':
        case 'field-row':
        case 'divider':
        case 'static':
        case 'text':
        case 'display':
        case 'section-label':
        case 'OASISMultiselectOption':
          break;
        case 'table':
          for (const row of node.rows) {
            addWhenGateRefQidsToSet(ids, row);
          }
          break;
        case 'sum':
          for (const t of node.terms) {
            ids.add(t.qid);
            if (t.countWhen != null) ids.add(t.countWhen.qid);
          }
          break;
        case 'conditional':
          addWhenGateRefQidsToSet(ids, node);
          break;
        case 'disabled-when':
          addConditionalClauseRefQidsToSet(ids, node.whenAll);
          break;
        case 'repeat':
          if (node.over.kind === 'multiselectOptionsOf') {
            ids.add(node.over.qid);
          }
          break;
        case 'OASISRadio':
        case 'OASISYesNoCheckbox':
        case 'OASISSelect':
        case 'OASISText':
        case 'OASISDate':
        case 'OASISTime':
        case 'OASISNumber':
        case 'OASISMultiselect':
        case 'radio-option':
          ids.add(node.qid);
          break;
        default:
          assertLayoutNodeExhaustive(node);
      }
      walkLayoutStructureChildren(node, walk);
    }
  };
  walk(nodes);
  return ids;
}
